import useCmsPolling from 'Utils/hooks/useCmsPolling';

const CmsPolling = () => {
  useCmsPolling();
  return null;
};

export default CmsPolling;

